import { render, staticRenderFns } from "./CandidateEmployeeCard.vue?vue&type=template&id=2daabf12&scoped=true"
import script from "./CandidateEmployeeCard.vue?vue&type=script&lang=ts"
export * from "./CandidateEmployeeCard.vue?vue&type=script&lang=ts"
import style0 from "./CandidateEmployeeCard.vue?vue&type=style&index=0&id=2daabf12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daabf12",
  null
  
)

export default component.exports